module.exports = __webpack_public_path__ + "img/card_open_section.61011cbb.png";